import { init } from '@instantdb/react'
import schema from '../instant.schema'

const appId = process.env.REACT_APP_INSTANT_APP_ID

if (!appId) {
  console.warn(
    'Missing REACT_APP_INSTANT_APP_ID. Add it to .env.local and restart the dev server.'
  )
}

export const db = init({
  appId: appId || '',
  schema,
})
